import Button from 'components/Button';
import Checkbox from 'components/Checkbox';
import FormActionGroup from 'components/FormActionGroup';
import Modal from 'components/Modal';
import PlusComponent from 'components/PlusComponent';
import Select from 'components/Select';
import Typography from 'components/Typography';
import {useHistory} from 'react-router-dom';
import styles from './MessageModal.module.scss';
import {PropsWithChildren} from 'react';
import {SelectOption} from 'types';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  username: string;
  handleChannelChange: (name: string, isChecked: boolean) => void;
  sendChannels: {
    sms: boolean;
    email: boolean;
    push: boolean;
  };
  sendMessage: () => void;
  messageTemplates?: SelectOption[];
  selectedTemplate?: SelectOption;
  onSelect: (option: SelectOption) => void;
} & PropsWithChildren<unknown>;

function MessageModal({
  isOpen,
  onClose,
  username,
  sendChannels,
  handleChannelChange,
  children,
  sendMessage,
  messageTemplates,
  onSelect,
  selectedTemplate,
}: Props) {
  const {push} = useHistory();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onRequestClose={onClose}
      className={styles.smsModal}
    >
      <Typography variant="h2">Send message to {username}</Typography>
      <div className={styles.checkboxContainer}>
        <label style={{display: 'flex', alignItems: 'center', gap: 6}}>
          <Checkbox
            name="sms"
            className={styles.checkbox}
            checked={sendChannels.sms}
            onChange={({target: {name, checked}}) =>
              handleChannelChange(name, checked)
            }
          />
          <span>SMS</span>
        </label>
        <label style={{display: 'flex', alignItems: 'center', gap: 6}}>
          <Checkbox
            name="email"
            className={styles.checkbox}
            checked={sendChannels.email}
            onChange={({target: {name, checked}}) =>
              handleChannelChange(name, checked)
            }
          />
          <span>Email</span>
        </label>
        <label style={{display: 'flex', alignItems: 'center', gap: 6}}>
          <Checkbox
            name="push"
            className={styles.checkbox}
            checked={sendChannels.push}
            onChange={({target: {name, checked}}) =>
              handleChannelChange(name, checked)
            }
          />
          <span>Push</span>
        </label>
      </div>
      {/* Textarea component for entering the message text */}
      {children}

      <div className={styles.label}>
        <div>Template</div>
        <PlusComponent onClick={() => push('/settings/templates/create')} />
      </div>
      <Select
        className={styles.templateSelect}
        placeholder="Select Template"
        options={messageTemplates}
        value={selectedTemplate}
        onChange={onSelect as any}
        // onChange={(option) => {
        //   setSelectedTemplate(option!);
        //   setMessage(option?.value as string);
        // }}
      />

      <FormActionGroup className={styles.buttonWrap}>
        <Button onClick={sendMessage} color="blue">
          Send
        </Button>
      </FormActionGroup>
    </Modal>
  );
}
export default MessageModal;
